import React from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import postalCodeRegex from "../../lib/postalCodeRegex";

class LocationSearchInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { address: "", removeAll: false };
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.removeAll &&
      !prevState.removeAll &&
      nextProps.removeAll !== prevState.removeAll
    ) {
      return {
        address: "",
        removeAll: true
      };
    }

    return null;
  }
  handleChange = address => {
    this.setState({ address, removeAll: false }, () => {
      const { onChange } = this.props;
      if (onChange) {
        onChange(address);
      }
    });
  };

  handleSelect = address => {
    const { onSubmit } = this.props;
    let self = this;
    const isPostalCode = postalCodeRegex(address);
    geocodeByAddress(address)
      .then(async results => {
        const formatted =
          (results[0] &&
            results[0].formatted_address &&
            results[0].formatted_address) ||
          "location not found!";
        const { lat, lng } = await getLatLng(results[0]);
        const address = results[0].address_components;
        return {
          lat,
          lng,
          address,
          formatted,
          isPostalCode
        };
      })
      .then(latLng => {
        self.setState(
          {
            address: latLng.formatted
          },
          () => {
            onSubmit(latLng);
          }
        );
      })
      .catch(error => console.error("Error", error));
  };
  handleFocus = event => {
    const { focusedText } = this.props;
    const input = document.getElementById("place-input");
    if (focusedText && input) {
      input.value = focusedText;
      input.select();
    } else {
      event.preventDefault();
    }
  };
  render() {
    const { placeholder, className, divClass, dropdownClass } = this.props;
    const { address } = this.state;
    let searchOptions = {};
    // eslint-disable-next-line
    if (__isBrowser__) {
      searchOptions = {
        componentRestrictions: { country: "uk" },
        types: ["geocode"]
      };
    }
    return (
      <PlacesAutocomplete
        value={address}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
        searchOptions={searchOptions}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
          return (
            <div className={divClass || ""}>
              <input
                value={address}
                autoFocus={!address || true}
                onFocus={this.handleFocus}
                {...getInputProps({
                  placeholder: placeholder || "Enter Zip Code...",
                  className: className || "location-search-input",
                  id: "place-input"
                })}
              />
              <div
                className={`autocomplete-dropdown-container ${dropdownClass ||
                  ""}`}
              >
                {loading && <div>Loading...</div>}
                {suggestions.map(suggestion => {
                  const className = suggestion.active
                    ? "suggestion-item--active"
                    : "suggestion-item";
                  const style = suggestion.active
                    ? { backgroundColor: "#fafafa", cursor: "pointer" }
                    : { backgroundColor: "#ffffff", cursor: "pointer" };
                  return (
                    <div
                      key={suggestion.id}
                      {...getSuggestionItemProps(suggestion, {
                        className,
                        style
                      })}
                    >
                      <span className="place-result">
                        {suggestion.description}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }}
      </PlacesAutocomplete>
    );
  }
}
export default LocationSearchInput;
